<template>
  <div>
    <div class="fv-txtbox">
      <div class="fv-title"><span class="dot">非</span><span class="dot">公</span><span class="dot">開</span>の<br /><span class="bg-blue">高</span><span class="bg-blue">年</span><span class="bg-blue">収</span><span class="bg-blue">求</span><span class="bg-blue">人</span>多数</div>
      <div class="fv-spbox">
        <div class="fv-subtxt">
          <div class="under-white"><span class="bold">業界No.1<span class="caution">※</span>の実績<br class="sp-view" /></span>エムスリーキャリアの<br /><span class="yellow-line">病院事務職専門</span><br class="sp-view" />転職支援サービス</div>
          <div class="zisya">※自社調べ</div>
        </div>
        <div class="fv-img-sp sp-view">
          <img :src="imagePaths.manSp" alt="" />
        </div>
      </div>
    </div>
    <div class="fv-img pc-tab-view">
      <img :src="imagePaths.man" alt="" />
    </div>
  </div>
</template>

<script>
export default {
  name: 'LpHero',
  props: {
    imagePaths: { type: Object, default: () => ({}) }
  }
}
</script>
